/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  getTheme,
  FontSizes,
  ICommandBarStyles,
  IStackStyles,
  IStackTokens,
  ITextStyles,
} from "@fluentui/react";

const theme = getTheme();

/**
 * Styling for the wrapper stack
 */
export const wrapperStackStyles = (): IStackStyles => {
  return {
    root: {
      padding: "0 3.25rem 0 1.25rem",
    },
  };
};

/**
 * Styling for the body stack
 */
export const bodyContainerExpeditedStackStyles = (): IStackStyles => {
  return {
    root: {
      margin: "0",
      borderRadius: " 8px",
      backgroundColor: theme.palette.white,
      padding: "0px 24px 24px 24px",
    },
  };
};

/**
 * Token for the body stack
 */
export const bodyContainerStackTokens = (): IStackTokens => {
  return { childrenGap: "1rem" };
};

/**
 * Styling for the question text
 */
export const questionTextStyles = (): ITextStyles => {
  return {
    root: {
      color: "#333333",
      fontSize: FontSizes.size16,
      fontWeight: 600,
      margin: "0 0 12px 0",
      display: "block",
    },
  };
};

/**
 * Styling for the question text
 */
export const answerTextStyles = (): ITextStyles => {
  return {
    root: {
      color: "#333333",
      fontSize: FontSizes.size16,
      fontWeight: 400,
      margin: "0 0 24px 0",
      display: "block",
    },
  };
};

/**
 * Styling for the command bar
 */
export const commandBarStyles = (): ICommandBarStyles => {
  return {
    root: {
      backgroundColor: theme.palette.white,
      borderRadius: "8px",
      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.2)",
      margin: "0 0.5rem 1.5rem 0.5rem",
    },
  };
};

/**
 * Questionnaire container styles
 */
export const questionnaireContainerStyles = (): IStackStyles => {
  return {
    root: {
      margin: "24px",
    },
  };
};

/**
 * Styling for the name text
 */
export const nameTextStyles = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size20, fontWeight: 600 } };
};

/**
 * Styling for the email text
 */
export const emailTextStyles = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size16, fontWeight: 400 } };
};

/**
 * Styling for the container stack
 */
export const containerStackTokens = (): IStackTokens => {
  return {
    childrenGap: 36,
  };
};

/**
 * Styling for the email stack
 */
export const emailStackTokens = (): IStackTokens => {
  return { childrenGap: 24, padding: "0.5rem 0 0 0" };
};

/**
 * Styling for the name info stack
 */
export const nameInfoStackStyles = (): IStackStyles => {
  return {
    root: {
      padding: "1.5rem",
      backgroundColor: theme.palette.white,
      borderRadius: "0.5rem",
    },
  };
};

export const mainContainerStyles = (): IStackStyles => {
  return {
    root: {
      backgroundColor: theme.palette.white,
      borderRadius: "8px",
      boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
      padding: "1.5rem",
    },
  };
};

export const errorMessageStyles = (): IStackStyles => {
  return {
    root: {
      margin: "0 24px",
    },
  };
};
